import Vue from 'vue';
import moment from 'moment';

Vue.filter('localTime', (value: string) => {
  const utc: Date = moment.utc(value).toDate();
  return moment(utc).format('M/D/YYYY h:mm a');
});

Vue.filter('localTimeOnly', (value: string) => {
  const utc: Date = moment.utc(value).toDate();
  return moment(utc).format('h:mm a');
});

Vue.filter('localDateOnly', (value: string) => {
  const utc: Date = moment.utc(value).toDate();
  return moment(utc).format('M/D/YYYY');
});
